import { render } from "./RecuperarSenha.vue?vue&type=template&id=fcac8a02&scoped=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"

import "./RecuperarSenha.vue?vue&type=style&index=0&id=fcac8a02&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcac8a02"]])

export default __exports__